<template>
  <FormItem :label="model.variable.label" :inline="inline">
    <Input type="text" v-model="model.val"></Input>
  </FormItem>
</template>

<script>
export default {
  name: 'datatime-element',
  data: function () {
    return {
      newVal: this.model.val
    }
  },
  // watch: {
  //   'val': function () {
  //     this.newVal = this.model.val
  //   }
  // },
  props: ['model', 'inline'],
  methods: {
    editVal: function () {
      this.model.val = this.newVal
      // this.$emit('editVal', this.model, this.newVal)
    }
  }
}
</script>
